/**
 * src/components/directory-page/FeaturedSection.js
 *
 * Sección "Negocios destacados - Plan Oro".
 * Fetchea /data/businesses.json directamente para reflejar cambios del admin.
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { signal, effect } from '@core/signal.js'
import { directoryData } from '@/db/directory.db.js'
import { uiIcons } from '@/shared/brandIcons.js'

const isActive = b => {
    if (b.enabled === false) return false
    const now = new Date()
    if (b.activeFrom && new Date(b.activeFrom) > now) return false
    if (b.activeTo   && new Date(b.activeTo)   < now) return false
    return true
}

define('FeaturedSection', ({ initialCategory = '', onCategoryChange } = {}) => {
    const search    = signal('')
    const category  = signal(initialCategory)
    const onlyOpen  = signal(false)
    const onlyPromo = signal(false)
    const sortMode  = signal('rating')
    const baseItems = signal([])

    const filtered = signal([])

    effect(() => {
        const base  = baseItems.get()
        const term  = search.get()
        const cat   = category.get()
        const open  = onlyOpen.get()
        const promo = onlyPromo.get()
        const sort  = sortMode.get()

        let list = base.filter(b => {
            if (term  && !b.name.toLowerCase().includes(term) &&
                         !b.category.toLowerCase().includes(term)) return false
            if (cat   && b.categorySlug !== cat) return false
            if (open  && !b.open)  return false
            if (promo && !b.hasPromo) return false
            return true
        })

        list = [...list].sort((a, b) => {
            if (sort === 'name')    return a.name.localeCompare(b.name)
            if (sort === 'reviews') return b.reviews - a.reviews
            return b.rating - a.rating
        })

        filtered.set(list)
    })

    const counter = h('p', { className: 'feat-section__count' })
    effect(() => {
        const n = filtered.get().length
        counter.textContent = `${n} negocio${n !== 1 ? 's' : ''} encontrado${n !== 1 ? 's' : ''}`
    })

    /* Fetch directo con cache buster */
    fetch(`/data/businesses.json?t=${Date.now()}`)
        .then(r => r.json())
        .then(data => {
            baseItems.set((data.items || []).filter(b => b.plan === 'oro' && isActive(b)))
        })
        .catch(() => {})

    return h('section', { className: 'feat-section' },
        h('div', { className: 'feat-section__inner' },
            h('div', { className: 'feat-section__head' },
                h('div', { className: 'feat-section__titles' },
                    h('span', { className: 'feat-section__label', innerHTML: uiIcons.star + ' Plan Oro' }),
                    h('h2',   { className: 'feat-section__headline' },
                        'Negocios destacados en Fusagasugá'),
                    h('p', { className: 'feat-section__desc' },
                        'Negocios verificados y destacados de Fusagasugá. Crecientes profesionales y negocios, ' +
                        'mercancías y recocinas negocios destacados en Fusagasugá.')
                ),
                counter
            ),
            c('FeaturedFilters', {
                categories: directoryData.categories,
                initialCategory,
                onSearch:   term => search.set(term),
                onCategory: slug => { category.set(slug); if (onCategoryChange) onCategoryChange(slug) },
                onOpen:     val  => onlyOpen.set(val),
                onPromo:    val  => onlyPromo.set(val),
                onSort:     mode => sortMode.set(mode)
            }),
            c('BusinessGrid', { businesses: filtered })
        )
    )
})
